<template>
    <el-form>
        <el-autocomplete class="inline-input search-component" v-model="form.keyword" :fetch-suggestions="querySearch" placeholder="请输入关键词来生成大数据词云" @select="handleSelect" @keyup.enter.native="to" popper-class="select-popper" ref="searchInput">
            <el-select v-model="form.type" slot="prepend" placeholder="请选择" class="select">
                <el-option :label="item.label" :value="item.value" v-for="item in searchTypeList" :key="item.value"></el-option>
            </el-select>
            <el-button id="default-generate" slot="append" class="button" @click="to">词云生成</el-button>

        </el-autocomplete>
        <el-button class="jiaocheng" @click="openJiaoChengUrl">使用教程</el-button>

    </el-form>

</template>
<script>
import { searchTypeList } from "../../assets/script/constant";
import Cookies from "js-cookie";
import { mapActions, mapMutations } from "vuex";
export default {
    componentName: "search",
    data() {
        return {
            form: {
                keyword: this.$route.params.keyword || "",
                type: this.$route.params.type || searchTypeList()[0].value
            },
            searchTypeList: searchTypeList()
        };
    },
    computed: {
        isChecking: {
            get() {
                return this.$store.state.wordfre.isChecking;
            },
            set(val) {
                this.$store.state.wordfre.isChecking = val;
            }
        }
    },
    methods: {
        _getToken() {
            //return 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjUyODIzNSIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL3NpZCI6IjUyODIzNSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvZXhwaXJhdGlvbiI6IjMvMy8yMDIwIDk6MDU6MzMgQU0iLCJuYmYiOjE1ODEwNjYzMzMsImV4cCI6MTU4MzIyNjMzMywiaWF0IjoxNTgxMDY2MzMzLCJpc3MiOiJ3d3cuNTExOC5jb20iLCJhdWQiOiJ3d3cuNTExOC5jb20ifQ.-Z839y2T-qUzZswhY8oHIbF3WsopKC6K6N3utq6NwG0';
            let user = Cookies.get("user");
            if (user) {
                return JSON.parse(user).token;
            }
            return "";
        },
        to() {
            if (!this.isChecking) {
                this.$refs.searchInput.activated = false;
                this.isChecking = true;
                if (!this.form.keyword) {
                    this.$alert("请输入内容");
                    return;
                }
                let token = this._getToken();
                if (!token) {
                    this.$alert("请先进行登录后再操作");
                    // this.MSet(null);
                    return;
                }
                this.savewordlist();
                this.$router
                    .push(
                        "/wordfrequency/" +
                            this.form.type +
                            "/" +
                            this.form.keyword
                    )
                    .catch(() => {
                        this.isChecking = false;
                    });
            } else {
                // this.$alert("您的关键词正在查询中，请耐心等待");
                this.$notify({
                    message: "您的关键词正在查询中，请耐心等待"
                });
            }
        },
        querySearch(queryString, cb) {
            let checkWords = [];
            if (localStorage.getItem("wordlists")) {
                checkWords = JSON.parse(localStorage.getItem("wordlists"));
                checkWords = checkWords.reverse();
                // 调用 callback 返回建议列表的数据
                cb(checkWords);
            } else {
                checkWords = [];
                cb(checkWords);
            }
        },
        handleSelect() {
            this.to();
        },
        savewordlist() {
            let savewordslist = [];
            let savestatus = true;
            if (localStorage.getItem("wordlists")) {
                savewordslist = JSON.parse(localStorage.getItem("wordlists"));
            }
            for (let i = 0; i < savewordslist.length; i++) {
                if (savewordslist.length >= 10) {
                    if (i === 0) {
                        savewordslist.splice(0, 1);
                    }
                }
                let checkword = savewordslist[i].value;
                if (checkword == this.form.keyword) {
                    savestatus = false;
                }
            }
            if (savestatus) {
                let keywordsinfo = { value: this.form.keyword };
                savewordslist.push(keywordsinfo);

                localStorage.setItem(
                    "wordlists",
                    JSON.stringify(savewordslist)
                );
            }
        },
        //打开教程链接
        openJiaoChengUrl() {
            window.open(
                "https://www.5118.com/toutiao/n/systemadd20200218140919773"
            );
        }
    }
};
</script>

<style type="text/less" lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";

.search-component {
    width: 600px;

    .select {
        background-color: white;
        width: 150px;
        color: @color-text-regular;
    }

    .button {
        background-color: @info-color;
        color: white;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
}

.jiaocheng {
    background-color: #fc9603;
    color: white;
    border: 0;
    position: absolute;
    height: 40px;
    margin-left: 10px;
}
</style>
<style type="text/less" lang="less">
@import "../../assets/style/color";

.search-component {
    .el-input__inner {
        border: none;
    }

    .el-input-group__append {
        background-color: @info-color;
        border-color: @info-color;
    }
}
.select-popper {
    margin-top: 5px !important;
    li {
        font-size: 12px;
    }
    li:hover {
        color: rgb(45, 125, 255);
    }
    .el-autocomplete-suggestion__wrap {
        max-height: 360px;
    }
}
</style>
